import {createContext, useContext} from 'react'
import {WizardContextValue} from './types'

export const WizardContext = createContext<WizardContextValue | null>(null)

export const useWizardContext = () => ({...useContext(WizardContext)})
